<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-27 
-->
<template>
  <div class="main-header">
    <span>
      <slot></slot>
    </span>
    <!-- <img :src="static_img_url+'pic/vbef.png'" /> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
    }),
  },
}
</script>
<style lang='stylus' scoped>
.main-header
  padding-top 10px
  padding-bottom 10px
  border-bottom 1px solid #eeeeee
  display flex
  justify-content space-between
  align-items center
  font-weight 700
  span
    font-size 24px
    line-height: 60px
    color #333333
  img
    height 60px
</style>